import { type ComponentPropsWithoutRef, forwardRef } from 'react'
import { InfoCircleIcon } from '@systemeio/icons'
import { cn } from 'cn'
import { useTranslation } from 'next-i18next/pages'

export const MaintenanceBanner = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  ({ className = '', ...props }, ref) => {
    const { t } = useTranslation()

    return (
      <div
        ref={ref}
        role="status"
        data-testid="maintenance-banner"
        className={cn(
          'relative flex flex-wrap items-center justify-center gap-1 rounded-none border border-x-0 border-border-warning bg-bg-warning p-2 [&_a]:underline',
          className,
        )}
        {...props}
      >
        <div className="flex items-center gap-2">
          <InfoCircleIcon
            className="hidden size-5 shrink-0 text-text-warning lg:block"
            aria-hidden="true"
            focusable="false"
          />
          <span className="flex flex-wrap items-center gap-1 text-sm font-normal text-text-primary">
            {t('core.error.maintenance_error_message')}
          </span>
        </div>
      </div>
    )
  },
)

MaintenanceBanner.displayName = 'MaintenanceBanner'
